var _style, _rect, _rect2, _g, _rect3, _rect4, _polygon, _rect5, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSextant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FECE56;stroke:#5A6063;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st2{fill:#FECE56;stroke:#B7B7B7;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{mask:url(#SVGID_1_);}\r\n\t.st4{fill:none;stroke:#5A6063;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#5A6063;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible"
    },
    width: 800,
    height: 844,
    xlinkHref: "3D43156.jpg",
    transform: "matrix(0.4288 0 0 0.4288 -21 -7)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 200.8,
    y: 27.5,
    transform: "matrix(0.786 -0.6183 0.6183 0.786 -34.7127 155.9198)",
    className: "st0",
    width: 14,
    height: 201.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 29.7,
    transform: "matrix(0.8082 0.5888 -0.5888 0.8082 93.253 -25.9438)",
    className: "st0",
    width: 14,
    height: 201.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,197.5C101.8,262,203.8,255,277.8,191c0,0,14.1,14.9,14,15c-50,51-174,94-283.5,8.5 C7.8,215,21.3,197.5,21.3,197.5z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 19.5,
    y: 204.5,
    width: 270,
    height: 63
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 19.5,
    y: 204.5,
    width: 270,
    height: 63,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.3,197.5C101.8,262,203.8,255,277.8,191c0,0,14.1,14.9,14,15c-50,51-174,94-283.5,8.5 C7.8,215,21.3,197.5,21.3,197.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 26.5,
    y1: 215.5,
    x2: 20.5,
    y2: 223.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 41.5,
    y1: 225.5,
    x2: 35.5,
    y2: 234.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 57.5,
    y1: 233.5,
    x2: 52.5,
    y2: 243.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 74.5,
    y1: 240.5,
    x2: 70.5,
    y2: 250.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 91.5,
    y1: 245.5,
    x2: 87.5,
    y2: 257.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 108.5,
    y1: 250.5,
    x2: 106.5,
    y2: 260.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 126.5,
    y1: 252.5,
    x2: 125.5,
    y2: 264.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 144.5,
    y1: 253.5,
    x2: 144.5,
    y2: 266.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 162.5,
    y1: 252.5,
    x2: 163.5,
    y2: 266.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 180.5,
    y1: 250.5,
    x2: 182.5,
    y2: 266.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 198.5,
    y1: 247.5,
    x2: 201.5,
    y2: 259.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 215.5,
    y1: 241.5,
    x2: 219.5,
    y2: 254.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 231.5,
    y1: 234.5,
    x2: 237.5,
    y2: 245.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 247.5,
    y1: 226.5,
    x2: 256.5,
    y2: 241.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 262.5,
    y1: 216.5,
    x2: 271.5,
    y2: 228.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 276.5,
    y1: 205.5,
    x2: 288.5,
    y2: 218.5
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170.5,
    y: 82.5,
    className: "st0",
    width: 18,
    height: 35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 88,
    className: "st0",
    width: 47,
    height: 24
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.5,85.5 223.5,86.5 188.5,86.5 188.5,114.5 223.5,114.5 223.5,115.5 238.5,115.5 238.5,85.5 "
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 89,
    className: "st0",
    width: 5,
    height: 22
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "76.3,257.9 53.6,253.9 55,246 47.1,244.6 43,268.2 50.9,269.6 52.2,261.7 74.9,265.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.7,
    y: 256.9,
    transform: "matrix(0.1736 -0.9848 0.9848 0.1736 -141.9169 384.6213)",
    className: "st0",
    width: 9,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1,
    y: 132,
    transform: "matrix(0.1736 -0.9848 0.9848 0.1736 -33.8383 251.7105)",
    className: "st0",
    width: 190,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.7,224.3l-8.9,50.2l72.9,12.8l8.9-50.2L81.7,224.3z M134,261.9l-41.4-7.3l2.6-14.8l41.4,7.3L134,261.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 137.8,
    y1: 93,
    x2: 116.5,
    y2: 214.2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 52.5,
    r: 33.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.2,
    y: 20.2,
    transform: "matrix(0.9325 0.3612 -0.3612 0.9325 29.0933 -50.6398)",
    className: "st0",
    width: 9.5,
    height: 64.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.5,97.2l-0.2,0.1c-2,0.8-4.3-0.2-5.1-2.3L88.2,65.9c-0.8-2,0.2-4.3,2.3-5.1l0.2-0.1c2-0.8,4.3,0.2,5.1,2.3 l11.1,29.1C107.6,94.2,106.5,96.4,104.5,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.5,118.2l-0.2,0.1c-2,0.8-4.3-0.2-5.1-2.3L77.2,86.9c-0.8-2,0.2-4.3,2.3-5.1l0.2-0.1c2-0.8,4.3,0.2,5.1,2.3 l11.1,29.1C96.6,115.2,95.5,117.4,93.5,118.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.5,119.2l-0.2,0.1c-2,0.8-4.3-0.2-5.1-2.3L60.2,87.9c-0.8-2,0.2-4.3,2.3-5.1l0.2-0.1c2-0.8,4.3,0.2,5.1,2.3 l11.1,29.1C79.6,116.2,78.5,118.4,76.5,119.2z"
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible"
    },
    width: 256,
    height: 256,
    xlinkHref: "3D43155.jpg",
    transform: "matrix(1.1719 0 0 1.1719 0 0)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSextant);
export default __webpack_public_path__ + "static/media/sextant.464605fa6bf46a6008715c3a9ef8266e.svg";
export { ForwardRef as ReactComponent };